import { useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
function Complaint() {
    const [formData, setFormData] = useState(
        {
            docType: "",
            docNo: "",
            selection: "",
            status: "",
            date: new Date(),
            name: "",
            mob_No: "",
            email: "",
            comp: "",
            action: "",
        }
    )
    const handleForm = (value, key) => {
        setFormData({ ...formData, [key]: value });
    }
    console.log(formData);
    return (
        <>

            <div className="body">
                <div className="container1" >

                    <form action="">
                        <div className="fields2">
                            <div className="input-field3">
                                <label htmlFor="" >Select Docket No</label>
                                <select value={formData.docType} onChange={(e) => handleForm(e.target.value, "docType")}>
                                    <option value="" disabled>Select Docket No</option>
                                    <option value="Docket No">Docket No</option>
                                    <option value="Vendor Docket No">Vendor Docket No</option>
                                </select>
                            </div>

                            <div className="input-field3">
                                <label htmlFor="" >Docket No</label>
                                
                                    <input type="text" placeholder="Docket No" className='input' value={formData.docNo} onChange={(e) => handleForm(e.target.value, "docNo")} />
                                    
                                        
                               
                            </div>

                            <div className="input-field3">
                                <label htmlFor="" >Selection</label>
                                <select value={formData.selection} onChange={(e) => handleForm(e.target.value, "selection")}>
                                    <option value="" disabled> Select Selection</option>
                                    <option value=""></option>
                                </select>
                            </div>

                            <div className="input-field3">
                                <label htmlFor="" >Status</label>
                                <select value={formData.status} onChange={(e) => handleForm(e.target.value, "status")}>
                                    <option value="" disabled> Select Status</option>
                                    <option value=""></option>
                                </select>
                            </div>

                            <div className="input-field3">
                                <label htmlFor="" >Date</label>
                                <DatePicker
                                    portalId="root-portal"
                                    selected={formData.date}
                                    onChange={(date) => handleForm(date, "date")}
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control form-control-sm"
                                    style={{ width: "120px", marginLeft: "10px" }}
                                />
                            </div>

                            <div className="input-field3">
                                <label htmlFor="" >Name</label>
                                <input className='input' type="text" placeholder='Name' value={formData.name} onChange={(e) => handleForm(e.target.value, "name")} />
                            </div>

                            <div className="input-field3">
                                <label htmlFor="" >Mobile No</label>
                                <input className='input' type="tel" maxLength={10} placeholder='Mobile No' value={formData.mob_No} onChange={(e) => handleForm(e.target.value, "mob_No")} />
                            </div>

                            <div className="input-field3">
                                <label htmlFor="" >Email ID</label>
                                <input className='input' type="email" placeholder='Email ID' value={formData.email} onChange={(e) => handleForm(e.target.value, "email")} />
                            </div>
                        </div>

                        <div className="fields2">
                            <div className="input-field">
                                <label htmlFor="" >Complaint</label>
                                <textarea type="text" placeholder='Enter Your Complaint Here...'
                                    value={formData.comp} onChange={(e) => handleForm(e.target.value, "comp")}
                                    rows={3} />
                            </div>

                            <div className="input-field">
                                <label htmlFor="" >Action</label>
                                <textarea type="text" placeholder='Action...'
                                    value={formData.action} onChange={(e) => handleForm(e.target.value, "action")}
                                    rows={3} />
                            </div>
                        </div>

                        <div className="bottom-buttons mt-4">
                            <button className='ok-btn'>Submit</button>
                            <button className='ok-btn'>Cancel</button>
                        </div>
                    </form>

                </div>
            </div>

        </>
    )
}

export default Complaint;